import styled from "styled-components";

export const Container = styled('div')`
    height: 100%;
    width: 100%;
    border-radius: 5px;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    box-shadow: 3px 3px 8px 1px rgb(0 0 0 / 18%);
    background: ${props => props.theme.colors.white_variant};

    & > .modal-header {
        height: 5rem;
        font-size: 1.3rem;
        font-weight: 500;
        padding: 20px;
        border-radius: 5px 5px 0 0;
        border-bottom: 1px solid #ebeaeacc;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    & > .modal-body {
        flex: 1;
        padding: 20px;
        overflow: auto;
    }

    & > .modal-footer {
        height: 2rem;
        padding: 20px;
        border-top: 1px solid #ebeaeacc;
        text-align: center;
    }
`;
